import Week from './week';

export default Week;
